import { DefaultDataSource } from './data-sources/'
import { IDataSourceBase } from './data-sources/data-source-base'

export class DataProvider {
    public dataSources: { [key: string]: IDataSourceBase | DefaultDataSource } = {}

    constructor() {
      this.dataSources.defaultDataSource = new DefaultDataSource()
    }

    async getList(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'getList', params)
    }

    getOne(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'getOne', params)
    }

    getMany(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'getMany', params)
    }

    getManyReference(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'getManyReference', params)
    }

    create(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'create', params)
    }

    update(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'update', params)
    }

    updateMany(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'updateMany', params)
    }

    delete(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'delete', params)
    }

    deleteMany(resource: string, params: any): Promise<any> {
      return this.callInstance(resource, 'deleteMany', params)
    }

    callInstance(resource: string, fn: keyof IDataSourceBase | keyof DefaultDataSource, params: any): Promise<any> {
      const instance = this.dataSources[resource] || this.dataSources.defaultDataSource
      if (instance && instance[fn] && typeof(instance[fn]) === 'function') {
        return instance instanceof DefaultDataSource ? instance[fn](resource, params) : instance[fn](params)
      }
      throw new Error('Unexpected error')
    }
}
